import { IDenominacion, IDivisa } from "@/entities";

export class Divisa implements IDivisa {
  codDivisa: string;
  simbolo: string;
  denominaciones: IDenominacion[];
  id: number;
  selected: boolean;

  constructor() {
    this.codDivisa = "";
    this.simbolo = "";
    this.denominaciones = [];
    this.id = 0;
    this.selected = false;
  }
}
